import type { ApolloCache } from '@apollo/client';

/** Zero normalized Message.unreadCount after a successful mark-read mutation. */
export function applyMarkMessageReadCacheUpdate(
  cache: ApolloCache<unknown>,
  data: { markMessageRead?: boolean | null } | null | undefined,
  messageId: string | undefined
) {
  if (data?.markMessageRead !== true || !messageId) return;
  const cacheId = cache.identify({ __typename: 'Message', id: messageId });
  if (!cacheId) return;
  cache.modify({
    id: cacheId,
    fields: { unreadCount: () => 0 },
  });
}
